import { useState } from "react";
import { SITE_URL, WRITE_API_URL } from "../../config/site";
import SEO from "../../components/SEO";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import "./ContactPage.css";

export default function ContactPage() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
    website: "",
  });

  const [status, setStatus] = useState({
    type: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    if (!form.name || !form.email || !form.message) {
      setStatus({
        type: "error",
        message: "Completa todos los campos antes de enviar.",
      });
      return;
    }

    try {
      setLoading(true);
      setStatus({
        type: "",
        message: "",
      });

      const response = await fetch(`${WRITE_API_URL}/contact.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || "No se pudo enviar el mensaje.");
      }

      setStatus({
        type: "success",
        message:
          "Mensaje enviado correctamente. Te responderemos lo antes posible.",
      });

      setForm({
        name: "",
        email: "",
        message: "",
        website: "",
      });
    } catch (error) {
      setStatus({
        type: "error",
        message: error.message || "Ha ocurrido un error al enviar el mensaje.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <SEO
  title="Contacto para pedidos personalizados | Imalandia"
  description="Contacta con Imalandia para dudas sobre pedidos, imanes personalizados, collages magnéticos, marcos y accesorios hechos con tus fotos."
  canonical={`${SITE_URL}/contacto`}
/>
      <Header />

      <main className="contact-page">
        <section className="contact-hero">
          <p className="contact-eyebrow">Contacto</p>

          <h1>¿Hablamos?</h1>

          <p>
            Si tienes dudas sobre un pedido, quieres personalizar un producto o
            necesitas ayuda antes de comprar, escríbenos.
          </p>
        </section>

        <section className="contact-card">
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="hidden"
              name="website"
              value={form.website}
              onChange={handleChange}
            />

            <label>
              Nombre
              <input
                type="text"
                name="name"
                placeholder="Tu nombre"
                value={form.name}
                onChange={handleChange}
              />
            </label>

            <label>
              Email
              <input
                type="email"
                name="email"
                placeholder="tu@email.com"
                value={form.email}
                onChange={handleChange}
              />
            </label>

            <label>
              Mensaje
              <textarea
                name="message"
                rows="6"
                placeholder="Cuéntanos en qué podemos ayudarte"
                value={form.message}
                onChange={handleChange}
              />
            </label>

            {status.message && (
              <p className={`contact-status ${status.type}`}>
                {status.message}
              </p>
            )}

            <button type="submit" disabled={loading}>
              {loading ? "Enviando..." : "Enviar mensaje"}
            </button>
          </form>

          <div className="contact-info">
            <h2>También puedes escribirnos</h2>

            <p>Para consultas sobre pedidos, personalización o incidencias.</p>

            <a href="mailto:info@imalandia.com">info@imalandia.com</a>

            <a href="tel:+34646273415">646 273 415</a>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
